import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const BASE_PATH = "/bo/custom-links";

const actions = {
    async listCustomLinks({ commit, dispatch }, { type } = {}) {
        try {
            const { data } = await Http.instance.get(BASE_PATH, {
                params: type ? { type } : undefined
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CUSTOM_LINKS", parseError);
            throw parseError;
        }
    },
    async createCustomLink({ commit, dispatch }, payload) {
        try {
            const { data } = await Http.instance.post(BASE_PATH, payload);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CUSTOM_LINKS", parseError);
            throw parseError;
        }
    },
    async updateCustomLink({ commit, dispatch }, { id, ...payload }) {
        try {
            const { data } = await Http.instance.patch(
                `${BASE_PATH}/${id}`,
                payload
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CUSTOM_LINKS", parseError);
            throw parseError;
        }
    },
    async deleteCustomLink({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(`${BASE_PATH}/${id}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CUSTOM_LINKS", parseError);
            throw parseError;
        }
    },
    async updateCustomLinksWeights({ commit, dispatch }, { customLinks }) {
        try {
            await Http.instance.put(`${BASE_PATH}/massive/weights`, {
                customLinks: customLinks
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_CUSTOM_LINKS", parseError);
            throw parseError;
        }
    }
};

export default actions;
